import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgCheckOut = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    stroke="#4D4D4D"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M8 7.393v7.775m0 0 3.393-3.393m-3.394 3.393-3.393-3.393m9.667 2.648v-8.65l-6.255-4.39H8l-6.256 4.39v8.65" />
  </svg>
);
const Memo = memo(SvgCheckOut);
export default Memo;
